import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { ClientLibrary } from 'types/client-library'
import type { State } from 'types/redux'
import { clientLibraryUpdate } from '@disco/state-management/actions/client-library-list-actions'
import { getClientLibrary } from '@disco/state-management/selectors/client-libraries'
import DocumentHeadTags from 'components/document-head-tags'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import ErrorText from 'components/ui/error-text'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import TextField from 'components/ui/text-field'
import { useFormState } from 'hooks/use-form-state'
const FORM_FIELDS = ['name']

const LibrariesLibraryRename = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ libraryId: string }>()
  const libraryId: number = parseInt(params.libraryId!, 10)
  const library: ClientLibrary = useSelector((state: State) =>
    getClientLibrary(state, libraryId),
  )
  const error = useSelector((state: State) => state.clientLibraries.list.errors)
  const [formState, setFormState] = useFormState(library, FORM_FIELDS)

  const handleCancel = () => navigate(-1)

  const handleSubmit = (event: React.SyntheticEvent<any>) => {
    event.preventDefault()
    dispatch(clientLibraryUpdate(libraryId, formState))
    navigate(-1)
  }

  const libraryLoading = library && library['loading']
  return (
    <ModalWindow
      header={<Heading size={700}>Rename Catalog</Heading>}
      footer={
        error?.non_field_errors && (
          <ErrorText>{error.non_field_errors}</ErrorText>
        )
      }
      actions={
        <ButtonContainer>
          <Button caption="Cancel" onClick={handleCancel} />
          <Button
            appearance="primary"
            caption="Rename"
            disabled={
              !formState['name'] || formState['name'] === library['name']
            }
            onClick={handleSubmit}
          />
        </ButtonContainer>
      }
      isOpen={true}
      onClose={handleCancel}
    >
      <DocumentHeadTags title="Create New Catalog | DISCO" />
      <TextField
        autoFocus
        loading={libraryLoading}
        error={error?.name}
        label="Name"
        value={formState['name']}
        onChange={event => setFormState('name', event.target.value)}
      />
    </ModalWindow>
  )
}

export default LibrariesLibraryRename
